import {
  fireHydrantIcon,
  noParkingIcon,
  speedLimitIconGeneric,
  stopSignIcon,
  trafficLightIcon,
  turnRuleIcon,
  turnRuleEUIcon,
  signIcon,
  highwaySignIcon,
  speedSignEUIcon,
  trafficFlowIcon,
} from '@/components/ui/icons/map/trackedCell';
import { ClassLabel } from './label';

export const CLASS_LABEL_ICONS: Partial<Record<ClassLabel, string>> = {
  'fire-hydrant': fireHydrantIcon(),
  'unknown-sign': signIcon(),
  'traffic-light': trafficLightIcon(),
  'speed-sign': speedLimitIconGeneric(),
  'parking-restriction': noParkingIcon(),
  'stop-sign': stopSignIcon(),
  'turn-rules-sign': turnRuleIcon(),
  'highway-sign': highwaySignIcon(),
  'speed-sign-eu': speedSignEUIcon(),
  'turn-rules-eu': turnRuleEUIcon(),
  'movement-regulation-sign': trafficFlowIcon(),
};

export const CLASS_LABEL_ICONS_GRAYSCALE: Partial<Record<ClassLabel, string>> =
  {
    'fire-hydrant': fireHydrantIcon(true),
    'traffic-light': trafficLightIcon(true),
    'speed-sign': speedLimitIconGeneric(true),
    'parking-restriction': noParkingIcon(true),
    'stop-sign': stopSignIcon(true),
    'turn-rules-sign': turnRuleIcon(true),
    'turn-rules-eu': turnRuleIcon(true),
  };

export const CLASS_LABEL_ICONS_MAP_FEATURE: Partial<
  Record<ClassLabel, string>
> = {
  'fire-hydrant': fireHydrantIcon(false, true),
  'unknown-sign': signIcon(true),
  'traffic-light': trafficLightIcon(false, true),
  'speed-sign': speedLimitIconGeneric(false, true),
  'parking-restriction': noParkingIcon(false, true),
  'stop-sign': stopSignIcon(false, true),
  'turn-rules-sign': turnRuleIcon(false, true),
  'highway-sign': highwaySignIcon(true),
  'speed-sign-eu': speedSignEUIcon(true),
  'turn-rules-eu': turnRuleEUIcon(true),
  'movement-regulation-sign': trafficFlowIcon(true),
};

export function getClassLabelIcon(
  classLabel: ClassLabel,
  isGrayScale?: boolean,
  isMapFeature?: boolean,
): string | undefined {
  if (isMapFeature) {
    return CLASS_LABEL_ICONS_MAP_FEATURE[classLabel] ?? undefined;
  }
  if (isGrayScale) {
    return CLASS_LABEL_ICONS_GRAYSCALE[classLabel] ?? undefined;
  }
  return CLASS_LABEL_ICONS[classLabel] ?? undefined;
}
